import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, throwError } from 'rxjs';
import { ApiService } from './api.service';
import { map,catchError } from 'rxjs/operators';
import { HttpClient, HttpParams } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class GoogleMapService {

  private _mapInstance = new BehaviorSubject<any>({});
  mapInstance = this._mapInstance.asObservable();
  mapStatic:any = {};
  
  roadApiUrl = "https://roads.googleapis.com/v1/snapToRoads";
  gkey = "AIzaSyARcR8g54_ekDkA-Y7YBvGwYe7cC9MFiWg";
  
  constructor(private apiservice: ApiService, private http: HttpClient) { }
  
  setMapInstance(value){
	this._mapInstance.next(value);
	this.mapStatic = value;
  }
  
  initOnMap(){
	if(!this.mapStatic?.mapTypeId){
		let map = new google.maps.Map(document.getElementById("gmp") as HTMLElement, {
			zoom: 12,
			center: {
				lat: 3.129958,
				lng: 101.67509
			}
		});
		this.setMapInstance(map);
		google.maps.event.addListener(map, 'zoom_changed', () => {
			let zoomLevel = map.getZoom();
			if(zoomLevel > 14){
				//this.map.setZoom(14)
			}
		});
	}
	return this.mapStatic;
  }
  
  //AIzaSyARcR8g54_ekDkA-Y7YBvGwYe7cC9MFiWg
  snappedData(pathValues): Observable <any>{
	// get URL Endpoint
	let endpoint = this.roadApiUrl;
	// set full URL to be requested
	let fullPathUrl = endpoint;
	let params:any = new HttpParams();
	params = params.append('interpolate', true);
	params = params.append('key', this.gkey);
	params = params.append('path', pathValues.join('|'));
	
	// send to backend via API service, standard place to perform HTTP transfer
	return this.http.get(fullPathUrl, { params: params })
	.pipe(
		map((results:any) => {
			return results;
		}),
		catchError((error:any) => {
			return throwError(error);
		})
	)
  }

}
